import api from './api'

export default {
    fetchGuide(params) {
      return api.get(`guide/`, params)
                .then(response => response.data)
    },
    postGuide(payload) {
      return api.post(`guide/`, payload)
                .then(response => response.data)
    },
}